import config from '../../assets/config/config.json';

export class EntryPoints {
  
  //static host : string = 'http://localhost:5000/';
  //static host : string = 'https://apiwalkers.scalelink.com/';

  host: string = config.apiBaseUrlRemote;

  constructor() {}

  public hostName: string = this.host +'api/';    

  //AnalogReaders
  public getReaderInputsGroupByPlantAndMeasurementTypeUrl = this.hostName + 'AnalogReaders/GetReaderInputsGroupByPlantAndMeasurementType?plant_id=%s&measurement_type=%d';
  public getDrawGroupByPlantUrl = this.hostName + 'AnalogReaders/GetDrawGroupByPlant?plant_id=%s';
  public getMeasurementTypesByPlantUrl = this.hostName + 'AnalogReaders/GetMeasurementTypesByPlant?plant_id=%s';
  public getReaderInputsByPlantUrl = this.hostName + 'AnalogReaders/GetReaderInputsByPlant?plant_id=%s';
  public getSensorPointsUrl = this.hostName + 'AnalogReaders/GetSensorPoints?reader_ids=%s&measurement_type=%s&group_ids=%s&start_date=%s';
  public getDrawTPHPointsUrl = this.hostName + 'AnalogReaders/GetDrawTPHPoints?group_id=%s&start_date=%s';
  public getSensorReportUrl = this.hostName + 'Reports/GetSensorReport?sensors=%s&startDate=%s&endDate=%s';
  public getReaderInputsByPlantAndTypeUrl = this.hostName + 'AnalogReaders/GetReaderInputsByPlantAndType?plant_id=%s&sensor_type=%d';
  public getMaxMinByDayForSensorsUrl = this.hostName+'AnalogReaders/MaxMinByDayForSensors?reader_ids=%s&start_date=%s&end_date=%s'
  
  //Dashboard
  public getCurrentReadingsUrl = this.hostName +'Dashboard/GetCurrentReadings?scales=%s';
  public getLastStatusUrl = this.hostName +'Dashboard/GetLastStatus?plant_id=%d';
  public getProductionAnalyticsUrl = this.hostName +'Dashboard/GetProductionAnalytics?plant_id=%d';
  public getAllProductionAnalyticsUrl = this.hostName +'Dashboard/GetAllProductionAnalytics';
  public getCurrentSensorValueUrl = this.hostName + 'Dashboard/GetSensorReading?sensors=%d';
  public getDashboardtatusUrl = this.hostName+'Dashboard/GetDashboardtatus?plant_id=%d';
  public listenDashboardMessagesUrl = this.host +'dashboard_messages';

  //DowntimeReasons
  public getDowntimeReasonsUrl = this.hostName+'DowntimeReasons/GetDowntimeReasons';
  public getGeneralDowntimeReasonsByPlantUrl = this.hostName+'DowntimeReasons/GetGeneralDowntimeReasonsByPlantId?plant_id=%d';
  public deleteDowntimeReasonByPlantUrl =  this.hostName+'DowntimeReasons/DeleteDowntimeReasonByPlant?plant_id=%d&downtime_reason_id=%d'
  public getMissingDowntimeReasonByPlantUrl = this.hostName+'DowntimeReasons/GetMissingReasonByPlant?plant_id=%d';
  public addMissingDowntimeReasonByPlantUrl = this.hostName+'DowntimeReasons/AddMissingDowntimeReasonByPlant';
  public createDowntimeReasonUrl = this.hostName+'DowntimeReasons/CreateDowntimeReason';
  public deleteDowntimeReasonUrl = this.hostName+'DowntimeReasons/DeleteDowntimeReason?downtime_reason_id=%d';
  public updateDowntimeReasonUrl = this.hostName+'DowntimeReasons/UpdateDowntimeReason';
  public getDowntimeEquipmentReasonsByPlantUrl = this.hostName+'DowntimeReasons/GetDowntimeEquipmentReasonsByPlant?plant_id=%d';
  public getAvailableDowntimeReasonsByEquipmentTypeUrl = this.hostName+'DowntimeReasons/GetAvailableDowntimeReasonsByEquipmentType?plant_id=%d&equipment_type_id=%d';
  public getDowntimeReasonsByEquipmentTypeUrl = this.hostName+'DowntimeReasons/GetDowntimeReasonsByEquipmentType?plant_id=%d&equipment_type_id=%d';
  public addEquipmentTypeDowntimeReasonUrl = this.hostName+'DowntimeReasons/AddEquipmentTypeDowntimeReason';
  public removeEquipmentTypeDowntimeReasonUrl = this.hostName+'DowntimeReasons/RemoveEquipmentTypeDowntimeReason';
  public getDowntimeReasonsWithNoEquipmentUrl = this.hostName+'DowntimeReasons/GetDowntimeReasonsWithNoEquipment?plant_id=%d';

  //EquipmentNames
  public createEquipmentNameUrl = this.hostName+'EquipmentNames/CreateEquipmentName';
  public deleteEquipmentNameUrl = this.hostName+'EquipmentNames/DeleteEquipmentName?equipment_name_id=%d';
  public updateEquipmentNameUrl = this.hostName+'EquipmentNames/UpdateEquipmentName';
  public getEquipmentNameByPlantIdUrl = this.hostName+'EquipmentNames/GetEquipmentNameByPlantId?plant_id=%d';
  public getEquipmentNameByScale = this.hostName+'EquipmentNames/GetEquipmentNameByScale?scale_id=%d';

  //EquipmentTypes
  public getEquipmentTypesUrl = this.hostName+'EquipmentTypes/GetEquipmentTypes';
  public createEquipmentTypeUrl = this.hostName+'EquipmentTypes/CreateEquipmentType';
  public updateEquipmentTypeUrl = this.hostName+'EquipmentTypes/UpdateEquipmentType';
  public deleteEquipmentTypeUrl = this.hostName+'EquipmentTypes/DeleteEquipmentType?equipment_type_id=%d';
  public getEquipmentTypeByPlantUrl = this.hostName+'EquipmentTypes/GetEquipmentTypeByPlant?plant_id=%d';

  //PlantBreaks
  public createPlantBreakUrl = this.hostName+'PlantBreaks/CreatePlantBreak';
  public getPlantBreakListByPlantUrl = this.hostName+'PlantBreaks/GetPlantBreakListByPlant?plant_id=%d';
  public deletePlantBreakUrl = this.hostName+'PlantBreaks/DeletePlantBreak?id=%d';
  public deleteBreakProductionUrl = this.hostName+'PlantBreaks/DeletePlantBreakFromProduction?breakId=%d&productionId=%d';
  public getProgrammedBreaksByproductionUrl = this.hostName+'PlantBreaks/GetProgrammedBreaksByProduction?production_id=%d';
  public createBreakInProductionUrl = this.hostName+'PlantBreaks/CreateBreaksInProduction?production_id=%d';
  public getProgrammedBreaksByDateRangeUrl = this.hostName+'PlantBreaks/GetProgrammedBreaksByDateRange?plant_id=%d&start_date=%s&end_date=%s';
  
  //Plants
  public getUserPlantsUrl = this.hostName+'Plants/GetUserPlants';
  public createReducedHoursUrl = this.hostName+'Plants/AddReducedHoursOnWeek';
  public getCurrentShelfUrl = this.hostName +'Plants/GetCurrentShelf?plant_id=%d';
  public forcePlantSynchronizationUrl = this.hostName+'Plants/ForcePlantSyncronization';
  public getPlantList = this.hostName+'Plants/GetPlantList';

  //Productions
  public updateProductionUrl = this.hostName+'Productions/UpdateProduction';
  public createProductionUrl = this.hostName+'Productions/CreateProduction';
  public deleteProductionAndTargetUrl = this.hostName+'Productions/DeleteProductionAndTargets?production_id=%d';

  //Products
  public getScaleProductsUrl = this.hostName+'Products/GetProductsByScale?scale_id=%s';
  public getProductsByPlantUrl = this.hostName+'Products/GetProductsByPlant?plant_id=%d';
  public createProductUrl = this.hostName+'Products/CreateProduct';
  public updateProductUrl = this.hostName+'Products/UpdateProduct';
  public deleteProductUrl = this.hostName+'Products/DeleteProduct?product_id=%d';
  public addScaleProductUrl = this.hostName+'Products/AddScaleProduct';
  public removeScaleProductUrl = this.hostName+'Products/RemoveScaleProduct';
  public setactiveScaleProductUrl = this.hostName+'Products/SetScaleProductActive';

  //ProgrammedDowntimes
  public createProgrammedDowntimeUrl = this.hostName+'ProgrammedDowntimes/CreateProgrammedDowntime';
  public createProgrammedDowntimeByShiftUrl = this.hostName+'ProgrammedDowntimes/CreateProgrammedDowntimeByShift';
  public getProgrammedDowntimesByPlantUrl = this.hostName+'ProgrammedDowntimes/GetProgrammedDowntimesByPlant?plant_id=%d';
  public getProgrammedDowntimesByShiftByPlantUrl = this.hostName+'ProgrammedDowntimes/GetProgrammedDowntimesByShiftByPlant?plant_id=%d';
  public deleteProgrammedDowntimeByIdUrl = this.hostName+'ProgrammedDowntimes/DeleteProgrammedDowntimeById?programmed_downtime_id=%d';
  public deleteProgrammedDowntimeByShiftByIdUrl = this.hostName+'ProgrammedDowntimes/DeleteProgrammedDowntimeByShiftById?programmed_downtime_id=%d';

  //Records
  public getLivePointsUrl = this.hostName +'Records/GetLivePoints?scale_ids=%s&minutes=%d';
  public getDailyTotalsByScaleUrl = this.hostName+'Records/GetDailyTotalsByScale?scale_ids=%s&startDate=%s&endDate=%s';
  public getPercentagesByScaleUrl = this.hostName+'Records/GetPercentages?inputScales=%s&outputScales=%s&startDate=%s&endDate=%s';
  public getDailyTotalsByProductUrl = this.hostName+'Records/GetDailyTotalsByProduct?product_id=%s&startDate=%s&endDate=%s';
  public getDailyTotalsByScaleAndShiftUrl = this.hostName+'Records/GetDailyTotalsByScaleAndShift?scale_ids=%s&plantShift_id=%d&startDate=%s&endDate=%s';
  public getDailyTotalsByProductAndShiftUrl = this.hostName+'Records/GetDailyTotalsByProductAndShift?product_id=%s&plantShift_id=%d&startDate=%s&endDate=%s';
  public getLinePointsUrl = this.hostName+'Records/GetLinePoints?scale_ids=%s&date=%s';
  public getLineSpeedPointsUrl = this.hostName+'Records/GetLineSpeedPoints?scale_ids=%s&date=%s';
  public getLineConsumptionPointsUrl = this.hostName+'Records/GetLineConsumptionPoints?plant_id=%d&date=%s';
  public getRecordHistoryUrl = this.hostName+'Records/GetRecordHistory?scale_id=%s&start=%s&end=%s';
  
  //Reports
  public getPeriodAPRUrl = this.hostName+'Reports/GetPeriodAPR?plant_id=%d&shift_id=%d&startDate=%s&endDate=%s';
  public getGlobalAPRUrl = this.hostName+'Reports/GetPeriodAPRAllPlants?startDate=%s&endDate=%s';
  public getPerformanceReportUrl = this.hostName+'Reports/GetPerformanceReport?plant_id=%d&date=%s';
  public getDowntimeAnalysisDataUrl = this.hostName+'Reports/GetDowntimeAnalysisData?plant_id=%d&startDate=%s&endDate=%s';
  public getProductionReportUrl = this.hostName+'Reports/GetProductionReport?production_id=%d';
  public getDailyTotalReportUrl = this.hostName+'Reports/GetDailyTotalsReport?scale_id=%s&startDate=%s&endDate=%s';
  public getWeeklyReportUrl = this.hostName+'Reports/GetWeeklyReport?scale_id=%s&startDate=%s&endDate=%s';
 
  //Scales
  public getScalesByPlantUrl = this.hostName+'Scales/GetScaleInfoByPlant?plants=%s';
  public getLoadScalesByPlantUrl = this.hostName+'Scales/GetLoadScalesInfoByPlant?plant_id=%s';
  public getScalesDowntimeByPlantUrl = this.hostName+'Scales/GetScalesDowntimeByPlant?plant_id=%d';
  public getPlantScalesUrl = this.hostName+'Scales/GetScalesByPlant?plant_id=%s';
  public getCurrentProductsInProductionByScaleUrl = this.hostName+'Scales/GetCurrentProductsInProductionByScale?scale_id=%d';
  public SetCurrentProductInProductionUrl = this.hostName+'Scales/SetCurrentProductInProduction';
  public updateScaleValuesUrl = this.hostName+"Scales/UpdateScale";
  public getZeroRecordsByScaleAndDateRangeUrl = this.hostName+"Scales/GetZeroRecordsByScaleAndDateRange?scale_id=%d&start_date=%s&end_date=%s";
  public insertScaleEquipment = this.hostName+"Scales/AddScaleEquipmentNames";
  public deleteScaleEquipment = this.hostName+"Scales/RemoveScaleEquipmentName";
  public getScalesBrandUrl = this.hostName+'Scales/GetScaleBrands';
  

  //ScaleStatus
  public getDowntimeUrl = this.hostName+'ScaleStatus/GetDowntimes?plant_id=%d&start_date=%s&end_date=%s';
  public getDowntimeByScaleUrl = this.hostName+'ScaleStatus/GetDowntimesByScale?scale_id=%d&start_date=%s&end_date=%s';
  public getScaleStatusUrl = this.hostName+'ScaleStatus/GetScaleStatus?scale_id=%d&shift_id=%d&start_date=%s&end_date=%s';

  //Shifts
  public createPlantShiftUrl = this.hostName+'Shifts/CreatePlantShift';
  public updatePlantShiftUrl = this.hostName+'Shifts/UpdatePlantShift';
  public CreatePlantShiftInProductionUrl = this.hostName+'Shifts/CreatePlantShiftInProduction?production_id=%d';
  public getPlantShiftsUrl = this.hostName+'Shifts/GetPlantShiftsByPlant?plant_id=%d';
  public getShiftsByProductionUrl = this.hostName+'Shifts/GetShiftsByProduction?production_id=%d';
  public deleteShiftProductionUrl = this.hostName+'Shifts/DeleteShiftsFromProduction?shift_id=%d&production_id=%d';
  public deletePlantShiftUrl = this.hostName+'Shifts/DeletePlantShift?plant_shift_id=%d';
  public getShiftsByDateRangeUrl = this.hostName+'Shifts/GetShiftsByDateRange?plant_id=%d&start_date=%s&end_date=%s';
  public GetShiftsApplyingForTodayUrl = this.hostName+'Shifts/GetShiftsApplyingForToday?plant_id=%d';
  public checkShiftDataUrl = this.hostName+'Shifts/CheckShiftData?plant_id=%d&start_date=%s&end_date=%s&shift_id=%d';
  public getShiftTypesUrl = this.hostName+'Shifts/GetAllShiftTypes';

  //Targets
  public getProgrammedDowntimesByDateRangeUrl = this.hostName+'Targets/GetProgrammedDowntimesByDateRange?plant_id=%d&start_date=%s&end_date=%s';
  public getPlantTargetsUrl = this.hostName+'Targets/GetPlantTargets?plant_id=%d&product_id=%d&startDate=%s&endDate=%s';
  public createTargetByProductUrl = this.hostName+'Targets/CreateTargetByProduct';
  public deleteTargetByProductUrl = this.hostName+'Targets/DeleteTargetByProduct?target_id=%d';
  public updateTargetByProductUrl = this.hostName+'Targets/UpdateTargetByProduct';
  public getTargetsByProductByPlantUrl = this.hostName+'Targets/GetTargetsByProductByPlant?plant_id=%d';
  public getTargetsByProductByDateRangeUrl = this.hostName+'Targets/GetTargetsByProductByDateRange?plant_id=%d&startDate=%s&endDate=%s';
  public getPlantProductionsUrl = this.hostName+'Targets/GetPlantProductions?plant_id=%d';
  public getTargetsByProductionUrl = this.hostName+'Targets/GetTargetsByProduction?production_id=%d';
  public getProgrammedDowntimesByProductionUrl = this.hostName+'Targets/GetProgrammedDowntimesByProduction?production_id=%d';

  //TrucksFeeded
  public getTruckFeedUrl = this.hostName +'TrucksFeeded/GetTrucksFeededCount?plant_id=%d';

  //Users
  public loginUrl = this.hostName + 'Users/CreateToken';
  public requestResetPasswordUrl = this.hostName + 'Users/RequestResetPassword';
  public resetPasswordUrl = this.hostName + 'Users/ResetPassword';

  //Alarms
  public getAlarmsByPlantUrl = this.hostName + 'Alarms/GetAlarmsByPlant?plant_id=%d&startDate=%s&endDate=%s';

  //Loads
  public getLoadsByScaleUrl = this.hostName+'Loads/GetLoadsByScale?scaleId=%d';

  //Samples
  public getSamplesByScaleUrl = this.hostName+'Samples/GetSamplesByScale?scale_id=%d&startDate=%s&endDate=%s';

  //Plant Offset
  public createPlantOffsetUrl = this.hostName+'PlantOffset/Create';
  public updatePlantOffsetUrl = this.hostName+'PlantOffset/Update';
  public getPlantOffsetsByUserUrl = this.hostName+'PlantOffset/GetPlantOffsetsByUser';
  public getPlantOffsetsUrl = this.hostName+'PlantOffset/GetPlantOffsetsByPlant?plant_id=%d';
  public deletePlantOffsetUrl = this.hostName+'PlantOffset/DeletePlantOffset?plant_offset_id=%d';
  public getTimeZones = this.hostName+'PlantOffset/GetTimeZones';
  public getSlectedOffsetPlants = this.hostName+'PlantOffset/GetSlectedPlantOffsetsByUser';

  //Bin
  public createBinUrl = this.hostName+'Bins/CreateBin';
  public updateBinUrl = this.hostName+'Bins/UpdateBin';
  public getBinsUrl = this.hostName+'Bins/GetBinByPlant?plant_id=%d';
  public deleteBinUrl = this.hostName+'Bins/DeleteBin?bin_id=%d';

   //DbMigration
   public getDbMigrationHistoryUrl = this.hostName+'DataBaseMigration/GetAllHistory';
   public migrationUrl = this.hostName+'DataBaseMigration/Migration';
   public runMigartionScriptsUrl = this.hostName+'DataBaseMigration/RunMigartionScripts';
   


  //BinPostion
  public createBinPostionUrl = this.hostName+'BinPosition/CreateBinPosition';
  public updateBinPostionUrl = this.hostName+'BinPosition/UpdateBinPosition';
  public getbinPostionByIdUrl = this.hostName+'BinPosition/GetBinPositionById?id=%d';
  public deleteBinPostionUrl = this.hostName+'BinPosition/DeleteBinPosition?bin_id=%d&scale_id=%d';
  public getAllreadingoutputs = this.hostName+'SensorReadingOutput/GetAllSensorReadingOutputsBySensor';
  public getBinPostionByPlantIdUrl = this.hostName+'BinPosition/GetBinPositionByPlantId?plant_id=%d';
  public getAllBinpositionsbyBinIdUrl = this.hostName+'BinPosition/GetBinPositionByBinId?bin_id=%d&scale_id=%d';
}